<script>
  import { performSearch } from '../search-module.js';
  import { searchCursor, searching } from '../store.js';

  function loadMore(e) {
    e.preventDefault();
    return performSearch(true).then(() => {
      e.target.blur();
    });
  }
</script>

{#if $searchCursor.hasNextPage && !$searching}
  <div class="results-load-more">
    <button onclick={loadMore}>Load more</button>
  </div>
{/if}
